import { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const PrintIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M15 8V4.56c0-.2-.078-.391-.219-.532l-1.812-1.81c-.14-.14-.332-.218-.531-.218H5.75c-.412 0-.75.337-.75.75V8c-1.656 0-3 1.344-3 3v4.25c0 .412.337.75.75.75H5v1.25c0 .413.338.75.75.75h8.5c.412 0 .75-.337.75-.75V16h2.25c.413 0 .75-.338.75-.75V11c0-1.656-1.344-3-3-3zM6 3h6.338L14 4.662V10H6V3zm8 14H6v-3h8v3zm3-2h-2v-1.25c0-.412-.338-.75-.75-.75h-8.5c-.412 0-.75.338-.75.75V15H3v-4c0-1.103.897-2 2-2v1.25c0 .412.338.75.75.75h8.5c.412 0 .75-.338.75-.75V9c1.103 0 2 .897 2 2v4zm-.875-3.5c0 .344-.281.625-.625.625s-.625-.281-.625-.625.281-.625.625-.625.625.281.625.625z" />
        </SvgIcon>
    );
};
